import { graphql, useStaticQuery } from 'gatsby';
import React, { ReactElement } from 'react';
import CollectionsCard from '../collections-card';

// Displays the most recent featured collections. Limited to 3.
export default function CollectionsFeatured(): ReactElement {
  const data = useStaticQuery(graphql`
    query CollectionsFeaturedQuery {
      allStrapiLibraryCollection(
        filter: { featured: { eq: true } }
        limit: 3
        sort: { date: DESC }
      ) {
        nodes {
          title
          author {
            name
            image {
              url
            }
          }
          header {
            bgColor
            textColor
            image {
              url
            }
          }
        }
      }
    }
  `);

  return (
    <div className="collections-featured mb-16 grid auto-rows-[1fr] grid-cols-[repeat(auto-fill,_261px)] gap-8">
      {data.allStrapiLibraryCollection.nodes.map((node) => (
        <CollectionsCard
          key={node.id}
          title={node.title}
          headerBgColor={node.header.bgColor}
          headerTextColor={node.header.textColor}
          headerIllo={node.header.image.url}
        />
      ))}
    </div>
  );
}
